<template>
  <div>
    <div v-if="arraySelected.length > 0" class="mb-3">
      <template v-for="(item, index) in arraySelected">
        <div :key="index">
          <v-chip
            label
            color="primary"
            text-color="white"
            :close="index + 1 === arraySelected.length"
            @input="handleRemove(item.key)"
            >{{ item.value }}</v-chip
          >
          <em v-if="index + 1 < arraySelected.length" class="fas fa-chevron-right mx-1" />
        </div>
      </template>
    </div>
    <template v-if="arraySelected.length < 3">
      <div class="my-3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          outline
          type="text"
          :placeholder="$t('Search')"
          class="default-input"
          maxlength="255"
          name="search"
          hide-details
        />
      </div>
      <div v-if="filterOptions.length > 0">
        <v-list class="py-0">
          <v-list-tile
            v-for="(item, index) in filterOptions"
            :key="index"
            active-class="grey lighten-4 indigo--text"
            style="border: 1px solid #eee"
            class="mb-2"
            @click="handleSelectedOption(item, currentLevel)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <em class="fas fa-chevron-right" />
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </div>
      <div v-else class="my-4 text-xs-center">{{ $t('No data') }}</div>
    </template>
  </div>
</template>

<script>
import { NT_REASON } from '@/constants/nt.js'

export default {
  props: ['value'],
  data() {
    return {
      currentLevel: 1,
      selected: {},
      reasonOptions: [],
      arraySelected: [],
      search: ''
    }
  },
  computed: {
    ntReasonData() {
      return NT_REASON
    },
    filterOptions() {
      let options = []

      if (this.search) {
        options = this.reasonOptions.filter((option) =>
          option.toLowerCase().includes(this.search.toLowerCase())
        )
      } else {
        options = this.reasonOptions
      }
      return options
    },
    currentSelected() {
      return this.selected
    },
    isSingleLevel() {
      return this.ntReasonData
        .filter((obj) => obj.level_2 === undefined)
        .map((item) => item.level_1)
    }
  },
  watch: {
    // value: {
    //   handler() {
    //     this.initReason()
    //   },
    //   deep: true
    // },
    currentLevel(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.handleSetReasonOptions()
      }
    }
  },
  mounted() {
    this.initReason()
  },
  methods: {
    initReason() {
      const vm = this
      try {
        const tempData = vm.value

        if (tempData) {
          this.selected = tempData
          this.currentLevel = tempData.length + 1
          this.transformValue()
        }

        this.handleSetReasonOptions()
      } catch (error) {
        console.error(error)
      }
    },
    handleSetReasonOptions() {
      const vm = this
      try {
        let options = []
        const level = parseInt(vm.currentLevel)

        if (level === 1) {
          options = vm.ntReasonData.map((item) => item.level_1)
        } else {
          const filterCurrentData = vm.ntReasonData.find(
            (item) => item.level_1 === vm.selected.level_1
          )

          if (filterCurrentData) {
            if (level === 2) {
              options = filterCurrentData.level_2.map((el) => el.title)
            } else if (level === 3) {
              const tempLevel2Data = filterCurrentData.level_2
              const objSelectedLv2 = tempLevel2Data.find(
                (item) => item.title === vm.selected.level_2
              )
              options = objSelectedLv2.level_3.map((el) => el.title)
            }
          }
        }

        vm.reasonOptions = options
      } catch (error) {
        console.error(error)
      }
    },
    handleSelectedOption(value, level) {
      const vm = this
      try {
        vm.search = ''
        let tempSelected = vm.selected
        Object.assign(tempSelected, { [`level_${level}`]: value })
        vm.selected = tempSelected

        if (parseInt(level) === 1 && vm.isSingleLevel.includes(value)) {
          vm.transformValue()
          vm.$emit('onUpdateReasonData', value)
          vm.reasonOptions = []
        } else {
          if (parseInt(level) === 3) {
            vm.$emit('onUpdateReasonData', value)
          }
          vm.currentLevel++
          vm.transformValue()
        }
      } catch (error) {
        console.error(error)
      }
    },
    transformValue() {
      let selected = []
      if (Object.keys(this.selected).length > 0) {
        Object.keys(this.selected).forEach((item) => {
          selected.push({
            key: item,
            value: this.selected[item]
          })
        })
      }

      this.arraySelected = selected
      this.$emit('input', this.selected)
    },
    handleRemove(key) {
      const vm = this
      try {
        let tempSelected = vm.selected
        delete tempSelected[key]
        vm.selected = tempSelected

        const level = key.replace('level_', '')
        vm.currentLevel = level
        vm.transformValue()
        vm.$emit('onUpdateReasonData', null)

        if (Object.keys(vm.selected).length === 0 && vm.reasonOptions.length === 0) {
          vm.handleSetReasonOptions()
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/nt/ReasonManage.vue